/*
  This script handles related-custom.liquid section injecting new carousel into DOM:
    1. We watch and wait for mutation (carousel injection)
    2. We then externally load 'flickity-carousel-custom.js'
*/

(function() {
  // Constants
  const currentScript = document.currentScript;
  const parentSelector = currentScript.dataset.parentSelector;
  const externalScriptURL = currentScript.dataset.externalScriptUrl;

  // Helper Functions
  function loadExternalScript(url) {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.defer = true;
    script.dataset.parentSelector = parentSelector;
    script.dataset.waitForDomContent = false;

    const section = document.querySelector(parentSelector);
    section.appendChild(script);

    // TODO: Handle Error
    // script.onerror = function() {
    //   console.error(`Failed to load script: ${url}`);
    // };
  }

  // Main
  document.addEventListener('DOMContentLoaded', function() {
    const carouselWrapper = document.querySelector(`${parentSelector} div[data-related-section]`);
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.tagName && node.tagName.toLowerCase() === 'flickity-carousel') {
              loadExternalScript(externalScriptURL);
              observer.disconnect();
            }
          }
        }
      }
    });

    observer.observe(carouselWrapper, { childList: true });
  });
})();